/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsKeyspacesDestination } from '../models/AwsKeyspacesDestination';

export class KeyspacesTableRestoreDestination {
  'awsKeyspaces': AwsKeyspacesDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsKeyspaces",
      "baseName": "awsKeyspaces",
      "type": "AwsKeyspacesDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return KeyspacesTableRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

